import { useSearchParams } from 'react-router';
import { Button } from '@/components/ui/button';
import { BrandMark } from '../components/BrandMark';

const ERROR_MESSAGES: Record<string, string> = {
  access_denied: 'Inloggen is geannuleerd of dit Google-account heeft geen toegang tot deze planner.',
  authorization_request_not_found: 'Rond het inloggen af in dezelfde browser waarin je het begon.',
};
const DEFAULT_ERROR = 'Inloggen is niet gelukt. Probeer het opnieuw.';

export default function LoginPage() {
  const [params] = useSearchParams();
  const code = params.get('error');
  const message = code === null ? null : (Object.hasOwn(ERROR_MESSAGES, code) ? (ERROR_MESSAGES[code] ?? DEFAULT_ERROR) : DEFAULT_ERROR);

  return (
    <main className="mx-auto flex min-h-full max-w-lg flex-col justify-center p-6">
      <div className="panel flex flex-col items-start gap-6 p-8 sm:p-10">
        <BrandMark name="Weekplanner" size="large" />
        <div className="flex flex-col gap-2">
          <h1 className="text-3xl">Inloggen</h1>
          <p className="max-w-prose opacity-80">
            De weekplanner voor groep 8. Log in met het Google-account waarvoor de beheerder toegang heeft ingesteld.
          </p>
        </div>
        {message && (
          <p role="alert" className="max-w-prose rounded-md border border-l-4 border-l-[var(--danger)] px-3 py-2">
            {message}
          </p>
        )}
        <Button asChild size="lg" className="min-h-12 w-full text-base">
          <a href="/oauth2/authorization/google">Inloggen met Google</a>
        </Button>
        {import.meta.env.DEV && (
          <Button asChild variant="link" className="px-0">
            <a href="/api/dev/login?email=dev@example.com">Dev-login</a>
          </Button>
        )}
      </div>
    </main>
  );
}
